import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Splash.css';

function Splash() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // 애니메이션(3초)이 완료된 후 0.5초 뒤에 가상계좌 발급안내 페이지로 이동
        const timer = setTimeout(() => {
            navigate(`/guide${location.search || ''}`);
        }, 3000); // 3초 애니메이션 + 0.5초 대기

        return () => clearTimeout(timer);
    }, [navigate, location.search]);

    return (
        <div className="splash-container">
            <img 
                src="/img/ntoss_logo.png" 
                alt="ntoss logo" 
                className="splash-logo"
            />
        </div>
    );
}

export default Splash;
